import instance from '../../api';
import { message } from 'antd';
import { ErrorNotification } from '../../../Utils/data';

export const sdk = {
  async readSDK(
    type: 'MCU' | 'BLE',
    page: string | number = 1,
    perPage: string,
    is_active: boolean,
  ) {
    const { data } = await instance(
      `dashcam-sdk/list/${type}?page=${page}&perPage=${perPage}&is_active=${is_active}`,
    );

    return {
      data: data,
      count: data.count,
    };
  },
  async createSDK(formData: FormData) {
    const loadingKey = 'sdkUpload';
    try {
      const { data } = await instance('dashcam-sdk/create', {
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      message.success({ content: 'Uploaded successfully!', key: loadingKey, duration: 2 });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      message.error({ content: 'Upload failed!', key: loadingKey, duration: 2 });
    }
  },
  async deleteSDK(sdkID: number | string) {
    const key = 'deleting';
    message.loading({ content: 'Deleting...', key });

    try {
      const { data }: { data: any } = await instance(`dashcam-sdk/delete/${sdkID}`, {
        method: 'DELETE',
      }).then((res) => {
        setTimeout(() => {
          message.success({ content: 'Deleted successfully!', key, duration: 2 });
        }, 1000);
        return res;
      });

      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
  async updateSDK(sdkData: any, sdkId: number | string) {
    const loadingKey = 'sdkUpdate';
    message.loading({ content: 'Updating...', key: loadingKey, duration: 0 });

    try {
      const { data }: { data: any } = await instance(`dashcam-sdk/update/${sdkId}`, {
        method: 'PUT',
        data: sdkData,
      });

      message.success({ content: 'Updated successfully!', key: loadingKey, duration: 2 });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        const errorStatus = error.response.status;
        const errorMessage = error.response.data.error.message;
        ErrorNotification({ status: errorStatus, message: errorMessage });
      } else {
        console.error('Unexpected error during update:', error);
      }

      message.error({ content: 'Update failed!', key: loadingKey, duration: 2 });
    } finally {
      message.destroy(loadingKey);
    }
  },
};
